export const isCreatedWithinLast24Hours = (createdAt: any) => {
  const createdTime = new Date(createdAt).getTime(); // Convert to timestamp
  const now = Date.now();
  const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

  return now - createdTime <= TWENTY_FOUR_HOURS;
};
